(() => {
  if (window.featuredVideoRecipesInitialized) return;

  window.featuredVideoRecipesInitialized = true;

  const SELECTORS = {
    root: '[data-featured-video-recipes]',
    trigger: '[data-featured-video-trigger]'
  };

  const extractYouTubeId = (input) => {
    if (!input) return '';

    const value = String(input).trim();

    if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
      return value;
    }

    try {
      const url = new URL(value);

      const vParam = url.searchParams.get('v');
      if (vParam && /^[a-zA-Z0-9_-]{11}$/.test(vParam)) {
        return vParam;
      }

      if (url.hostname.includes('youtu.be')) {
        const id = url.pathname.split('/').filter(Boolean)[0];
        if (id && /^[a-zA-Z0-9_-]{11}$/.test(id)) {
          return id;
        }
      }

      const parts = url.pathname.split('/').filter(Boolean);
      const knownPathIndex = parts.findIndex((part) => ['embed', 'shorts', 'live'].includes(part));

      if (knownPathIndex !== -1 && parts[knownPathIndex + 1]) {
        const id = parts[knownPathIndex + 1];

        if (/^[a-zA-Z0-9_-]{11}$/.test(id)) {
          return id;
        }
      }
    } catch (error) {
      // Continue to regex fallback.
    }

    const match = value.match(/(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : '';
  };

  const buildIframe = (button) => {
    const rawVideoId = button.dataset.youtubeId || '';
    const rawVideoSource = button.dataset.youtubeSource || '';
    const videoId = extractYouTubeId(rawVideoId) || extractYouTubeId(rawVideoSource);
    const videoTitle = button.dataset.videoTitle || 'Video';

    if (!videoId) {
      console.warn('Featured Video Recipes: Missing or invalid YouTube ID.', {
        rawVideoId,
        rawVideoSource
      });
      return;
    }

    const media = button.closest('.featured-video-card__media');
    if (!media) return;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
    iframe.title = videoTitle;
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    media.innerHTML = '';
    media.appendChild(iframe);
    media.classList.add('featured-video-card__media--loaded');
  };

  const setupThumbnailFallbacks = (container = document) => {
    const images = container.querySelectorAll('img[data-featured-video-fallback-thumbnail]');

    images.forEach((image) => {
      if (image.dataset.featuredVideoFallbackInitialized === 'true') return;

      image.dataset.featuredVideoFallbackInitialized = 'true';

      image.addEventListener(
        'error',
        () => {
          const fallback = image.dataset.featuredVideoFallbackThumbnail;

          if (fallback && image.src !== fallback) {
            image.src = fallback;
          }
        },
        { once: true }
      );
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTORS.trigger);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    buildIframe(trigger);
  });

  const initAll = (container = document) => {
    container.querySelectorAll(SELECTORS.root).forEach((root) => {
      setupThumbnailFallbacks(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();